module.exports = __webpack_public_path__ + "img/facepaint-3_en.c3e7820.jpg";